import { SerpDisplayType } from '~/analytics/ActionAnalytics/actions/actionTypes';
import { SERPEvent, SERPEventType } from '../SERPEvents';

export type OpenEventDetail = {
    data: {
        serpType: SerpDisplayType;
    };
};

export type OpenEvent = CustomEvent<OpenEventDetail> & {
    type: SERPEventType.OPEN;
};

export const isOpenEvent = (event: SERPEvent): event is OpenEvent => {
    return typeof event === 'object' && event !== null && 'type' in event && event.type === SERPEventType.OPEN;
};
